import {FC} from 'react';
import {AvatarWrapper, AvatarWrapperBG} from '@atoms/Avatar.styles';

export interface AvatarProps {
  img?: string;
  size?: number;
  systemOwner?: boolean;
}

const Avatar: FC<AvatarProps> = ({img, size = 32, systemOwner = false}) => {
  return (
    <AvatarWrapper size={size} systemOwner={systemOwner}>
      <AvatarWrapperBG size={size} systemOwner={systemOwner}>
        <img src={img ? img : '/assets/user-no-avatar.svg'} alt="avatar" />
      </AvatarWrapperBG>
    </AvatarWrapper>
  );
};

export default Avatar;
